import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";

import { PrescriptionComponent } from "./prescription.component";
import { PrescriptionRoutingModule } from "./prescription-routing.module";
import { ViewPrescriptionComponent } from "./components/view-prescription/view-prescription.component";
import { PrescriptionsComponent } from "./components/prescriptions/prescriptions.component";
import { CreateComponent } from "./components/create/create.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SharedModule } from "../shared.module";
import { ProfileModule } from "../profile/profile.module";
import { ReplaceModalComponent } from "./components/replace-modal/replace-modal.component";
import { SummaryModalComponent } from "./components/summary-modal/summary-modal.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { FilledPrescriptionComponent } from "./components/filled-prescription/filled-prescription.component";
import { OnlyNumberDirective } from "./only-number.directive";
import { PrescripitonTokenComponent } from './components/prescripiton-token/prescripiton-token.component';
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
  declarations: [
    PrescriptionComponent,
    ViewPrescriptionComponent,
    PrescriptionsComponent,
    CreateComponent,
    ReplaceModalComponent,
    SummaryModalComponent,
    FilledPrescriptionComponent,
    OnlyNumberDirective,
    PrescripitonTokenComponent,
  ],
  imports: [
    CommonModule,
    PrescriptionRoutingModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatAutocompleteModule,
    ProfileModule,
    NgSelectModule
  ],
  exports: [CreateComponent, PrescriptionsComponent, ViewPrescriptionComponent, PrescripitonTokenComponent],
})
export class PrescriptionModule {}
